import '../css/ProductTab.css';

import * as React from 'react';

import {
  IBlank,
  ICropDivider,
  IPage,
  ISeedCategory,
  ISeedDivider,
  ITechSheet,
  IShelfDivider,
  ITechReferenceSheet
} from '../../../../../infrastructure/interfaces';
import { TooltipCont } from '../../../../../infrastructure/tooltips';
import AccordionItem from '../common/AccordionItem';
import BlankItem from './BlankItem';
import Logo from '../Logo';
import TOCItem from './TableOfContentItem';
import BlankPage from './BlankPage';
import { productType } from '../../../../../infrastructure/ProductType';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import SeedDividerItem from "./SeedDividerItem";
import TechSheetItem from './TechSheetItem';
import ShelfDividerItem from "./ShelfDividerItem";
import AgronomyReferenceSheetItem from './AgronomyReferenceSheetItem';

export interface IObjectProps {
  shelfDividers: IShelfDivider[];
  agronomyReferenceSheetsPublished: ITechReferenceSheet[];
  blanksPublished: IBlank[];
  techSheets: ITechSheet[];
  seedCategories: ISeedCategory[];
  seedDividers: ISeedDivider[];
  cropDividers: ICropDivider[];
  pages: IPage[];
  docType : string;
}

export default class ObjectTab extends React.Component<IObjectProps> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { shelfDividers, agronomyReferenceSheetsPublished, blanksPublished, seedCategories, seedDividers, techSheets } = this.props;

    let containsNote = blanksPublished.find(b => b.src == 'note');
    if (!containsNote) {
      blanksPublished.splice(0, 0, { src: 'note', type: placeholderTypes.Blank, id: 9001, published: true, title: '', url: ''});
    }
    if(this.props.docType !== productType.Bulletin) {
      return <div className="sidePane">
        <div className="productTab">
          <div className="divider-box">
            <BlankPage type={'item'} title="Blank Pagination Page"/>
            <TOCItem type={'item'}/>
            <AccordionItem
                key={1}
                title="Section Divider Page"
            >
              <div className="divider-box-sub">
                <AccordionItem
                    key={1}
                    title="Product Shelf Dividers"
                >
                  <ul className="product-list">
                    {shelfDividers.sort((a, b) => a.category.name.localeCompare(b.category.name)).map((d, i) => (
                        <ShelfDividerItem
                            shelfDivider={d}
                            type={'item'}
                            key={i}
                            title={TooltipCont.PRODUCT_DIVIDER_DRAG}
                        />
                    ))
                    }
                  </ul>
                </AccordionItem>
                <AccordionItem
                    key={2}
                    title="Seed Dividers"
                >
                  <ul className="product-list">
                    {seedDividers.sort((a, b) => a.category.name.localeCompare(b.category.name)).map((s, i) => (
                        <SeedDividerItem
                            seedDivider={s}
                            type={'item'}
                            key={i}
                            title={TooltipCont.PRODUCT_DIVIDER_DRAG}
                        />
                    ))
                    }
                  </ul>
                </AccordionItem>
              </div>
            </AccordionItem>
            <AccordionItem
                key={3}
                title="Advertisements"
            >
              <ul className="product-list">

                {blanksPublished
                  .sort((a: IBlank, b: IBlank) => (a.id < b.id) ? 1 : -1)
                  .map((b, i) => (
                    <BlankItem
                        blank={b}
                        type={'item'}
                        key={i}
                    />))
                }
              </ul>
            </AccordionItem>
            <div className="divider-box">
              <AccordionItem
                key={4}
                title="Seed Tech Sheets"
              >
                {seedCategories.sort((a, b) => a.name.localeCompare(b.name)).map((seed, seedIndex) => (
                <div className="divider-box-sub">
                  <AccordionItem
                    key={seedIndex}
                    title={seed.name}
                  >
                    <ul className="product-list-techhseets">
                        {techSheets.map((t, i) => {
                          if(seed.id === t.category.id)
                          return <TechSheetItem
                            techSheet={t}
                            type={'item'}
                            key={i}
                          />
                          return <div></div>
                          })
                        }
                    </ul>
                  </AccordionItem>
                  </div>
                ))}
              </AccordionItem>
            </div>

            <div className="divider-box">
              <AccordionItem
                key={5}
                title="Agronomy and Sustainability"
              >
                <ul className="product-list">
                  {agronomyReferenceSheetsPublished
                    .sort((a: ITechReferenceSheet, b: ITechReferenceSheet) => (a.id < b.id) ? 1 : -1)
                    .map((a, i) => (
                      <AgronomyReferenceSheetItem
                          agronomyReferenceSheet={a}
                          type={'item'}
                          key={i}
                      />
                      ))
                  }
                </ul>
              </AccordionItem>
            </div>
          </div>
        </div>
        <Logo/>
      </div>;
    }
    else {
      return (
        <div className="sidePane">
          <div className="productTab">
            <div className="divider-box">
              <AccordionItem
                key={1}
                title="Tech Sheets"
              >
                {seedCategories.sort((a, b) => a.name.localeCompare(b.name)).map((seed, seedIndex) => (
                <div className="divider-box-sub">
                  <AccordionItem
                    key={seedIndex}
                    title={seed.name}
                  >
                    <ul className="product-list-techhseets">
                        {techSheets.map((t, i) => {
                          if(seed.id === t.category.id)
                          return <TechSheetItem
                            techSheet={t}
                            type={'item'}
                            key={i}
                          />
                          return <div></div>
                          })
                        }
                    </ul>
                  </AccordionItem>
                  </div>
                ))}
              </AccordionItem>
            </div>
          </div>
          <Logo />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ObjectTab/ObjectTab.tsx